// extracted by mini-css-extract-plugin
export default {"popup":"overlay-popup-module-popup-c-SdY","content":"overlay-popup-module-content-QkNgJ","closeBtn":"overlay-popup-module-closeBtn-VUqHI"};